// extracted by mini-css-extract-plugin
module.exports = {"notice":"TermsOfUse_notice__1Ez5e"};